// extracted by mini-css-extract-plugin
module.exports = {"divClass":"PaymentRecord_divClass__MbUHF","divContent":"PaymentRecord_divContent__3M4iB","contentClass":"PaymentRecord_contentClass__2D-EW","oneDiv":"PaymentRecord_oneDiv__3Sgf9"};